﻿import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { CommonModule } from "@angular/common";
import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { SharedModule } from "../../../components/shared/shared.module";
import { BsDropdownModule, CollapseModule, ModalModule, TooltipModule } from "ngx-bootstrap";

// ------------------------------------------Start Service----------------------------------------------------------------------//
import { CompanyTableComponent } from "./table/company-table.component";
import { InterceptorService } from "../../../service/components/authentication/interceptor.service";
import { CompanyManageService } from "../../../service/api/jubili/company-manage.service";
import { NgbDropdownModule, NgbModule } from "@ng-bootstrap/ng-bootstrap";;
import { CompanySettingFormComponent } from './company-setting-form/company-setting-form.component'
// import { BsDropdownModule, CollapseModule, ModalModule, TooltipModule } from "ngx-bootstrap";

// ------------------------------------------End Service----------------------------------------------------------------------//

@NgModule({
    imports: [
        CommonModule,
        HttpClientModule,
        FormsModule,
        BrowserModule,
        RouterModule,
        SharedModule,
        NgbDropdownModule,
        NgbModule.forRoot(),
        BsDropdownModule.forRoot(),
        CollapseModule.forRoot(),
        ModalModule.forRoot(),
        TooltipModule.forRoot(),

        SharedModule
    ],
    declarations: [
        CompanyTableComponent,
        CompanySettingFormComponent
    ],
    exports: [
        CompanyTableComponent,
        SharedModule
    ],
    bootstrap: [
        CompanyTableComponent
    ],
    providers: [
        { provide: HTTP_INTERCEPTORS, useClass: InterceptorService, multi: true },
        CompanyManageService
    ]
})

export class CompanyManageModule { }
